{
  "checkoutForm": {
    "title": "Vul je gegevens in",
    "consent": "Als abonnee van {0} {1} per e-mail nieuws, aantrekkelijke aanbiedingen en productinformatie. {2} kunt dit wijzigen bij {3}"
  },
  "durationSelector": {
    "title": "Kies je {0}",
    "titleWithoutDiscounts": "Kies je looptijd",
    "tempDurationTitle": "Je kortingsperiode",
    "singleDurationTitle": "Jouw kortingsperiode",
    "duration": {
      "footerText": "{0} korting",
      "temporaryPromoBadge": "Tijdelijke actie"
    },
    "disclaimer": {
      "default": "Na deze periode kan je maandelijks opzeggen.",
      "afterDuration": "Na {0} {1} kan je maandelijks opzeggen.",
      "cancel": "Je kunt je bestelling binnen 14 dagen annuleren."
    }
  },
  "productOverview": {
    "title": "Kies jouw nieuwe tijdschrift",
    "filterCategory": "Filter op categorie",
    "filterType": "Filter op type",
    "noResults": "Sorry! We kunnen niet vinden wat je zoekt.",
    "results": "We waren op zoek naar",
    "search": "Zoeken",
    "clear": "Reset"
  },
  "links": {
    "productCardCta": "Bekijk aanbod",
    "discoverAll": "Ontdek alles"
  },
  "thema": {
    "proefabonnementen": {
      "title": "Proefabonnementen",
      "subtitle": "Drie nummers op te proberen"
    }
  }
}